import type { AssetAllocation } from "Infrastructure/ApiZfp/Schema";

export const formatTwoDecimals = (value: number | null | undefined): string => {
  return new Intl.NumberFormat("cs-CZ", { maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(value ?? 0);
};

/**
 * Rounds asset allocation percentages to integers using the Largest Remainder Method.
 * Ensures the final sum is exactly 100%.
 */
export const roundAllocationTo100Percent = (allocation: AssetAllocation): AssetAllocation => {
  const keys = Object.keys(allocation) as (keyof AssetAllocation)[];

  // Calculate floor values and collect decimal remainders
  const items = keys.map((key) => ({
    key,
    value: Math.floor(allocation[key]),
    remainder: allocation[key] % 1,
  }));

  const currentSum = items.reduce((sum, item) => sum + item.value, 0);
  const diff = 100 - currentSum;

  // Sort by remainder descending to identify which items to increment
  const prioritizedItems = [...items].sort((a, b) => b.remainder - a.remainder).slice(0, diff);

  // Add 1 to the top items
  for (const item of prioritizedItems) {
    item.value++;
  }

  const result = {} as AssetAllocation;
  for (const item of items) {
    result[item.key] = item.value;
  }

  return result;
};
